import ApplicationController from '../application_controller.js'

/*
 * Transfer to cfile
 */

export default class TransferToIfileController extends ApplicationController {

  static targets = ["checkBox"]

  clickCheck(e) {
    this.enableSubmit()
  }

  selectDestinationIfile(e) {
    this.enableSubmit()
  }

  select_deselect(e) {
    e.target.closest("form").querySelectorAll(".record_selector").forEach(checkbox => {
      checkbox.checked = e.target.checked
    })
    this.enableSubmit()
  }

  enableSubmit() {
    var can = false

    this.element.closest("form").querySelectorAll(".record_selector").forEach(e => {
      if (e.checked) {
        can = true
      }
    })

    can = can && this.element.closest("form").querySelector("#destination_ifile_id").selectedIndex > 0

    var sub = this.element.closest("form").querySelector("input[type=submit]")
    sub.disabled = !can
  }

}